var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconChalkboardTeacher = function SvgIconChalkboardTeacher(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.375 7.875a1 1 0 0 1 1-1h11.25a1 1 0 0 1 1 1v8.25a1 1 0 1 1-2 0v-7.25H6.375a1 1 0 0 1-1-1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M3.75 3.5A1.75 1.75 0 0 0 2 5.25v13.5a1.75 1.75 0 0 0 1.75 1.75h1.753a1 1 0 0 0 .942-.664 3.51 3.51 0 0 1 6.61 0 1 1 0 0 0 .942.664h6.253A1.75 1.75 0 0 0 22 18.75V5.25a1.75 1.75 0 0 0-1.75-1.75zm.25 15v-13h16v13h-5.349a5.5 5.5 0 0 0-2.154-2.26 3.625 3.625 0 1 0-5.494 0 5.5 5.5 0 0 0-2.154 2.26zm5.75-6.25a1.625 1.625 0 1 0 0 3.25 1.625 1.625 0 0 0 0-3.25",
    clipRule: "evenodd"
  }))));
};
export default SvgIconChalkboardTeacher;